import React from 'react';
import { Link } from 'react-router-dom';

import { getSeriesList } from '../../actions/series';
import GroupedList from '../../components/GroupedList';
import { topLevelSeriesSelector } from '../../selectors';

import c from './Series.less';

function SeriesList(props) {
  return (
    <GroupedList
      componentName="SeriesList"
      title="Mp3Caprice - Music Series"
      description="A big choice of music series to all tastes. Discover, buy and download high quality tunes for reasonable prices."
      header="Music series"
      loadData={getSeriesList}
      mapData={(store) => topLevelSeriesSelector(store)}
      itemRender={(item) => (<Link className={c.seriesLink} to={`/series/${item.slug}`}>{item.name}</Link>)}
      pathPrefix="series"
      {...props}
    />
  );
}

export default SeriesList;
